export default {
  name: "Frankly Solutions",
  href: "https://frankly.solutions/",
  links: [
    {
      name: "Instagram",
      href: "www.instagram.com/frankly.solutions",
    },
    {
      name: "LinkedIn",
      href: "https://hr.linkedin.com/company/frankly-solutions",
    },
  ],
};
